var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"drift-glyph-icon",class:_vm.rarity,attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true","focusable":"false"}},_vm._l((_vm.paths),function(path,index){return _c('path',{key:index,attrs:{"d":path}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }